import { Injectable } from '@angular/core';
import { DashletData } from './chart-data.service';

@Injectable({
  providedIn: 'root'
})
export class ChartExcelExportService {

  constructor() { }
  processData(data: DashletData | any): any[] {
    let extractedData;

     if (data.bar && data.bar.series?.length) {
      if (data.groupedChart) {
        extractedData = data.bar.series.flatMap((seriesItem: any) =>
          data.categories.map((category: string, index: number) => ({
            Category: category,
            Group: seriesItem.name || 'N/A',
            Value: this.toFixed(seriesItem.data[index] || 0,2)
          }))
        );
       } else {
        extractedData=data.pie
        return extractedData.map(item => ({
          Category: item.Category || item.name || item.category || item.key,
          Value: this.toFixed(item.Value || item.value, 2)
        }));
       }

    
    } else if (Array.isArray(data)) {
      extractedData = data;
    }

    return extractedData.map(item => ({
      Category: item.Category || item.name || item.category || item.key,
      Group: item.Group || item.group,
      Value: this.toFixed(item.Value || item.value,2)
    }));
  }
  toFixed(number, digits) {
    return parseFloat(parseFloat(number).toFixed(digits));
  }


    
}
